
<template>
  <div class="auth-wrapper d-flex no-block justify-content-center align-items-center">
    <div class="auth-box">
      <div id="loginform">
        <div class="logo">
          <span class="db">
            <img src="@/assets/images/logos/logo-full.png" alt="logo">
          </span>
          <h5 class="font-medium mb-3">Sign In to Admin</h5>
        </div>
        <!-- Form -->
        <div class="row">
          <div class="col-12">
            <div class="form-horizontal mt-3">
              <div v-if="errorMessage" class="alert alert-danger" role="alert">
                <i class="fa fa-exclamation-triangle fa-fw" aria-hidden="true"></i>
                {{ errorMessage }}
              </div>

              <div class="form-group text-center">
                <div class="col-xs-12 pb-3">
                  <button class="btn btn-block btn-lg google-btn" type="button" @click="googleLogin">
                    <svg class="google-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18" height="18">
                      <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
                      <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
                      <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
                      <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
                    </svg>
                    Sign in with Google
                  </button>
                </div>
              </div>

              <div class="form-group mb-0 mt-2">
                <div class="col-sm-12 text-center">Mind The Gap studio</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="h-screen flex w-full bg-img" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <form
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
              @submit.prevent="login"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4 title-page">Ahaslides Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>
                <vs-input
                  name="email"
                  icon="icon icon-user"
                  icon-pack="feather"
                  label-placeholder="Email"
                  v-model="email"
                  class="w-full no-icon-border"
                  required
                />

                <vs-input
                  type="password"
                  name="password"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Password"
                  v-model="password"
                  class="w-full mt-6 no-icon-border"
                  required
                />

                <div class="flex flex-wrap justify-between my-5">
                  <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                </div>
                <div class="text-danger text-sm" v-if="textError">{{ textError }}</div>

                <div class="text-center">
                  <vs-button style="width: 100%">
                    Login
                    <i class="feather icon icon-loader" v-if="summiting"></i>
                  </vs-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </vx-card>
    </div>
  </div>-->
</template>



<script>
// @ is an alias to /src
// import Router from "@/router";
import Config from "@/config"

export default {
  name: "Login",
  data() {
    return {
      baseUrl: Config.baseUrl,
      errorMessage: ''
    }
  },
  mounted() {
    // Check if there's an error from the router query (from Auth.vue redirect)
    if (this.$route.query.error) {
      this.errorMessage = this.$route.query.error
      // Clean up the query parameter
      this.$router.replace({ name: 'Login' })
    }
  },
  methods: {
    setLang: function(lang) {
      this.$store.dispatch("setLang", lang)
    },

    googleLogin() {
      // Redirect to Google OAuth endpoint
      window.location.href = `${this.baseUrl}/api/auth/google/internal`
    },

    registerUser() {
      this.$router.push("/pages/register")
    }
  }
}
</script>

<style lang="scss" scope>
.auth-wrapper {
  background: url("../../assets/images/big/auth-bg.jpg") no-repeat center center;
}
.text-danger {
  margin-bottom: 15px;
}
.google-btn {
  background-color: white !important;
  color: #757575 !important;
  border: 1px solid #dadce0 !important;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
  text-decoration: none;
}
.google-btn:hover {
  background-color: #f8f9fa !important;
  box-shadow: 0 1px 2px 0 rgba(60,64,67,.30), 0 1px 3px 1px rgba(60,64,67,.15) !important;
  color: #3c4043 !important;
  text-decoration: none;
}
.google-btn:focus,
.google-btn:active {
  background-color: #f8f9fa !important;
  color: #3c4043 !important;
  text-decoration: none;
  outline: none;
  box-shadow: 0 1px 2px 0 rgba(60,64,67,.30), 0 1px 3px 1px rgba(60,64,67,.15) !important;
}
.google-icon {
  margin-right: 4px;
}
</style>
